// extracted by mini-css-extract-plugin
export default {"root":"widget-noItems_root__FzKw0","iconWrapper":"widget-noItems_iconWrapper__U3YAH","description":"widget-noItems_description__580Ks"};